import React, { useEffect, useRef } from "react";
import styled from "styled-components";
const ImageSlider = styled.div`
  margin-top: 20px;
  width: ${(props) => `${props.width}px`};
`;
const SliderWrapper = styled.div`
  width: ${(props) => `${props.width}px`};
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  margin: auto;
  &::-webkit-scrollbar {
    height: 0;
  }
`;
const SliderImage = styled.img`
  width: ${(props) => `${props.width}px`};
  background-color: #f9f9f9;
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
`;
const ImgWrapper = styled.div`
  position: relative;
`;
const ImgTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  left: 50%;
  bottom: 10%;
  transform: translateX(-50%);
  padding: 10px;
  background-color: #333;
  color: #fff;
`;
const Slider = ({ images, width }) => {
  const slider_wrraper = useRef();
  useEffect(() => {
    var temp = -1;

    var slider_wrraper_width = width * slider_wrraper.current.children.length;

    var time = setInterval(() => {
      var scroll_pos = slider_wrraper.current.scrollLeft;
      if (temp < slider_wrraper_width - 275) {
        slider_wrraper.current.scrollLeft += width + 22;
        temp = scroll_pos;
      } else {
        slider_wrraper.current.scrollLeft = "0";
        temp = -1;
      }
    }, 3000);
    return () => {
      clearInterval(time);
    };
  }, []);

  return (
    <ImageSlider width={width + 100} className="image-slider">
      <SliderWrapper
        className="slider-wrapper"
        ref={slider_wrraper}
        width={width + 21}
      >
        {images.map((it, i) => (
          <ImgWrapper>
            <SliderImage src={it.pic} alt="" key={i} width={width} />
            <ImgTag className="tag">
              <span>{it.tag}</span>
            </ImgTag>
          </ImgWrapper>
        ))}
      </SliderWrapper>
    </ImageSlider>
  );
};

export default Slider;
